import { SET_CART_LIST, SET_CART_CLEAR } from "./cart.types";

export const setCartList = (payload) => ({
    type: SET_CART_LIST,
    payload
});

export const setCartClear = () => ({
    type: SET_CART_CLEAR,
});


